/**
 * Inline SVG strings for the chrome — no emoji as UI icons, no icon font.
 * Stroke-based so they inherit `currentColor` from the button they sit in.
 */

const stroke = (d: string): string =>
  `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d}" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export const ICON_SOUND_ON = stroke(
  "M11 5L6 9H2v6h4l5 4V5z M15.54 8.46a5 5 0 0 1 0 7.07 M19.07 4.93a10 10 0 0 1 0 14.14",
);

export const ICON_SOUND_OFF = stroke("M11 5L6 9H2v6h4l5 4V5z M23 9l-6 6 M17 9l6 6");

export const ICON_BACK = stroke("M19 12H5 M12 19l-7-7 7-7");

export const ICON_UNDO = stroke("M1 4v6h6 M3.51 15a9 9 0 1 0 2.13-9.36L1 10");

export const ICON_RESTART = stroke(
  "M23 4v6h-6 M1 20v-6h6 M3.51 9a9 9 0 0 1 14.85-3.36L23 10 M1 14l4.64 4.36A9 9 0 0 0 20.49 15",
);

export const ICON_SHARE = stroke(
  "M12 3v12 M7 8l5-5 5 5 M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6",
);
